import { render, staticRenderFns } from "./SyntheseSirh.vue?vue&type=template&id=53b1a8ab&scoped=true"
import script from "./SyntheseSirh.vue?vue&type=script&lang=js"
export * from "./SyntheseSirh.vue?vue&type=script&lang=js"
import style0 from "./SyntheseSirh.vue?vue&type=style&index=0&id=53b1a8ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b1a8ab",
  null
  
)

export default component.exports